<template>
    <input type="tel" class="form-control inputs"
           v-model="val.formatted"
           @input="handleInput"
           @focus="$event.target.select()"
           :id="id"
    >
</template>

<script>
    export default {
        name: "InputPresentase",
        props: ["defaultValue", "id"],
        data() {
            return {
                val: {
                    formatted: "",
                    raw: 0,
                },
                run: false,
            }
        },
        computed: {
            val_formatted() {
                return this.val.formatted
            }
        },
        watch: {
            val_formatted(v, old) {
                // if (!this.run) {
                //     this.run = true
                    this.getValDecimal(v, old)
                // }
                // setTimeout(() => {
                //     this.run = false
                // },100)
            },
            defaultValue(v, old) {
              this.getValDecimal(v, old)
            },
            immediate: true

        },
        mounted() {
            this.val.formatted = this.defaultValue.toFixed(2).replace(".", ",")
        },
        created() {
            // alert('c' + this.val.formatted);
            // this.val.formatted = "22"
        },
        methods: {
            getValDecimal(value, oldValue) {
                var regexFormat = /^\d+(,\d{0,2})?$/;
                if (!regexFormat.test(value)) {
                    if (value.toString() === "") {
                        value = 0
                    } else {
                        this.val.formatted = oldValue
                        this.getRaw(oldValue)
                        return;
                    }
                }

                value = value.toString().replace(/[^0-9,]+/g, '')
                if (value.toString().substr(0,1) === "0") {
                    if (value.toString().substr(1,1) !== ",") {
                        value = value.toString().substr(1, value.lenght)
                    }
                }

            	if (value === "") {
            		this.val.formatted = "0"
		            this.val.raw = 0
		            this.handleInput()
		            return
	            }
                var resRegex = this.formatDecimal(value, oldValue)
                this.val.formatted = resRegex
                this.getRaw(resRegex)
	            this.$emit('input', this.val)
            },
            formatDecimal(angka, oldValue) {
	            var angkaFloat = angka.toString().replace(/[^0-9,]+/g, '');
	            var commaFloat = parseFloat(angkaFloat).toString().split(".")[1]
	            var commaStr = angkaFloat.split(",")[1]
	            
	            angkaFloat = angkaFloat.replace(/,/g, '.');
	            if (parseFloat(angkaFloat) > 100) {
		            return 100
	            }
	            if (commaStr !== undefined) {
		            if (commaStr.length > 2) {
			            return oldValue
		            }
	            }
	            if (commaFloat !== undefined) {
		            if (commaFloat.length > 2) {
			            return oldValue
		            }
	            }
	            return angka.toString().replace(".", ",")
            	
                // var formatAngka = angka.replace(/[^0-9,]+/, '');
                // var newValue = formatAngka.replace(/,/g, '.');
                // newValue = parseFloat(newValue);
                // if (newValue > 100) {
                //     newValue = "100";
                //     formatAngka = newValue
                // }
				//
                // if (formatAngka != "") {
                //     let regex = /^\d*(\.\d{1,2})?$/
                //     var afterComma = newValue.toString().split(".")[1];
                //         if (!newValue.toString().match(regex)) {
                //             return oldValue.replace(/[^0-9,]+/, '');
                //         }
                // }
				//
                // if (formatAngka.split(",")[1] != "") {
                //     if (!isNaN(newValue)) {
                //         return newValue.toString().replace(".", ',');
                //     }
                // }
                // if(formatAngka.substr(formatAngka.indexOf(',')+1,1)===","){
                //     return oldValue.replace(/[^0-9,]+/, '');
                // }
                // return formatAngka;

            },
            handleInput() {
                this.$emit('input', this.val)
            },

            getRaw(value) {
                var newValue = value.toString().replace(/,/g, '.');
                newValue = parseFloat(newValue).toFixed(2);
                if (newValue > 100) {
                    newValue = 100;
                }

                this.val.raw = parseFloat(newValue)
                // this.val.raw = parseFloat(value.replace(",", "."));
            }
        }
    }
</script>

<!--
<template>
    <input
            v-model="currentValue"
            @input="handleInput"
            min="0"
            max="100"
    />

&lt;!&ndash;    <input type="tel" class="form-control inputs" min="1" max="100"&ndash;&gt;
&lt;!&ndash;           placeholder="" value="0" v-on:keyup="onlynumberdiskon" v-model="diskon">&ndash;&gt;
</template>


<script>
    export default {
        name: "InputPresentase",
        data() {
            return {
                currentValue
                val: {
                    formatted: "",
                    raw: 0,
                },
            }
        },

        watch: {
            value: {
                handler(after) {
                    console.log(after);
                    // this.valraw = this.format(after)
                },
                immediate: true
            }
        },
        methods: {
            format(value) {
                console.log(value);
                return (value).replace(/[^0-9,]+/, '');

                // return (value + '').replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },

            handleInput() {
                this.currentValue =  this.format(this.currentValue)
                var newValue=(this.currentValue).replace(/,/g, '.');//.parseFloat(this.currentValue).toFixed(2);
                if(newValue>100){
                    newValue=100;
                }
                this.$emit('input', newValue )
            }
        }
    }
</script>

-->
